import { display } from "redux-react/reducers/snackBarReducer";
import { api } from "./api";

const actions = {
	getDictionary: (assistantID, onSuccess, onFailure) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/api/v1/rule/dictionary/${assistantID}`,
					onSuccess,
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: err.response?.data?.error ?? "none"
							})
						);
					}
				})
			);
		};
	},
	insertRule: (assistantID, data, onSuccess, onFailure) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/rule/add/${assistantID}`,
					data,
					onSuccess,
					onFailure
				})
			);
		};
	}
};

export default actions;
